<template>
  <div class="container">
    <div class="header">
      About Us
    </div>
    <div class="tabs">
      <div class="tabs__header">
        <router-link
          class="tabs__header__item"
          @click="onTabHeaderItemClick(index)"
          :class="{
            'tabs__header__item--active': $route.path.indexOf(tab.path) === 0
          }"
          v-for="(tab, index) in tabs"
          :key="index"
          :to="tab.path"
        >
          {{ tab.name
          }}<i class="iconfont acog-gengduo tabs__header__item__arrow"></i>
        </router-link>
      </div>
      <router-view></router-view>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../components/Footer";
export default {
  data() {
    return {
      current: 0,
      tabs: [
        {
          name: "About Us",
          path: "/about-us/brief"
        },
        {
          name: "Team",
          path: "/about-us/team"
        },
        {
          name: "Brands",
          path: "/about-us/brands"
        },
        {
          name: "Path",
          path: "/about-us/path"
        }
      ]
    };
  },
  methods: {
    onTabHeaderItemClick(index) {
      // this.current = index;
      switch (index) {
        case 1:
          this.$router.push({ path: "/about-us/team" });
          break;
      }
    }
  },
  components: {
    Footer
  }
};
</script>
<style lang="scss" scoped>
.header {
  height: 312px;
  background-image: url("../assets/aboutus_banner.png");
  background-position: center;
  background-size: auto 100%;
  background-repeat: no-repeat;
  overflow: hidden;
  color: #fefefe;
  font-size: 40px;
  text-align: center;
  font-weight: bold;
  padding-top: 80px;
  box-sizing: border-box;
}
.tabs {
  margin-top: -100px;
  &__header {
    height: 100px;
    vertical-align: middle;
    background-color: rgba(255, 255, 255, 0.2);
    &__item {
      cursor: pointer;
      height: 100px;
      line-height: 100px;
      display: inline-block;
      color: #fefefe;
      font-size: 26px;
      width: 25%;
      text-align: center;
      vertical-align: middle;
      position: relative;
      &__arrow {
        font-size: 16px;
        margin-left: 4px;
        vertical-align: middle;
      }
      &--active {
        color: #ec6900;
      }
    }
  }
}
.tabs__header__item:not(:first-child)::before {
  position: absolute;
  content: "";
  height: 56px;
  width: 2px;
  background-color: rgba(255, 255, 255, 0.3);
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
</style>